import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientCounts = (tenant) => {

  return useQuery({
    queryKey: ["patientCounts", tenant],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();

      const allPatientsResponse = await axiosInstance.get(
        `${tenant}/patient/get`,
        { params: { page: 1 } }
      );

      const myPatientsResponse = await axiosInstance.get(
        `${tenant}/patient/mypatients/get`,
        { params: { page: 1 } }
      );

      return {
        ALL: allPatientsResponse.data?.totalRecords || 0,
        MY: myPatientsResponse.data?.totalRecords || 0,
      };
    },
    staleTime: 1000 * 60 * 5,
  });
};